import {getheaders} from "./authService";

export async function getPropertyJobs(propertyId, startDate, endDate) {
    let requestOptions = {
        method: 'GET', 
        headers: getheaders(), 
        redirect: 'follow'
    };
    return fetch(`/api/jobs?start_date=${toDateString(startDate)}&end_date=${toDateString(endDate)}&property_id=${propertyId}`, requestOptions);
}

export async function getAllJobs(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/jobs/all?start_date=" + toDateString(startDate) + "&end_date=" + toDateString(endDate), requestOptions)
}

export async function getLostProperties(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/lost-properties?start_date=" + toDateString(startDate) + "&end_date=" + toDateString(endDate), requestOptions)
}

export async function getAllJobsString(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/jobs/all?start_date=" + startDate + "&end_date=" + endDate, requestOptions)
}

export async function getTaskBoardJobs() {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/tasks/board", requestOptions)
}

export async function getJobNotes(cosjobid) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobnote/" + cosjobid, requestOptions)
}

export async function getJobDetails(cosjobid) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobs/" + cosjobid, requestOptions)
}

export async function addJobNotes(cosjobid, notes) {
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify({
            "id": cosjobid,
            "note": notes
        })
    };
    return fetch("/api/jobnote", requestOptions)
}

export async function updateJobAdmin(jobDetails) {
    let reqbody = {
        ...jobDetails
    }
    if (reqbody.check_in != null && reqbody.check_in.length === 0) {

        reqbody.check_in = null;
    }
    reqbody.job_id = null
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/admin", requestOptions)
}

export async function createJob(jobDetails) {
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify(jobDetails)
    };
    return fetch("/api/jobs", requestOptions)
}

export async function assignJobWorker(jobId, workerId) {
    let reqbody = {
        "cos_job_worker": workerId, "cos_job_id": jobId,
    }
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/assign/worker", requestOptions)
}

export async function assignJobSupervisor(jobId, supervisorId) {
    let reqbody = {
        "cos_job_supervisor": supervisorId, "cos_job_id": jobId,
    }
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/assign/supervisor", requestOptions)
}


export function toDateString(inputDate) {
    try {
        return new Date(inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    } catch (e) {
        return new Date()
    }
}


export async function createOrUpdateParkingFee(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/parkingfee", requestOptions)
}

export async function getAllJobCount(payload) {
    let httpMethod = "POST";
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/summary/count", requestOptions)
}

export async function getParkingFee(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/parkingfee/" + cosJobId, requestOptions)
}

export async function getCheckList(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/checklist/" + cosJobId, requestOptions)
}

export async function createOrUpdateExtraCleaningFee(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/extracleaningfee", requestOptions)
}

export async function getExtraCleaningFee(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/extracleaningfee/" + cosJobId, requestOptions)
}

export async function toggleChecklistItem(itemId) {
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobs/checklist-items/" + itemId + "/toggle", requestOptions)
}

export async function deleteExtraCleaningFee(cosJobId) {
    let requestOptions = {
        method: 'DELETE', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/extracleaningfee/" + cosJobId, requestOptions)
}
